import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useFormikContext } from 'formik';

import Grid from '@material-ui/core/Grid';

import { getPath } from '../steps';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    }
  },
  submit: {
    minWidth: '85px',
  }
}));

type FormButtonsProps = {
  isSubmitting: boolean,
  isValid: boolean,
  step: number,
  steps: string[],
};

const FormButtons = ({ isSubmitting, isValid = false, step, steps }: FormButtonsProps ) => {
  const classes = useStyles();
    const history = useHistory();
    const [submitted, setSubmitted] = useState(false);
    const { setFieldValue } = useFormikContext();

    return (
    <Grid className={classes.root} container justify="space-between">
        <Grid item>
            {step !== 0 && (
          <Button
            onClick={() => {
              history.push(getPath(steps, step - 1))
            }}
            variant="outlined"
            type="button"
          >
            Back
          </Button>
        )}
        </Grid>
        <Grid item>
            {step !== steps.length - 1 ? (
          <Button
            onClick={() => {
              history.push(getPath(steps, step + 1));
            }}
            variant="outlined"
            type="button"
          >
            Next
          </Button>
        ) : (
          //<Button className={classes.submit} color="primary" disabled={!isValid || isSubmitting} type="submit" variant="contained">
          //  {isSubmitting ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
          //</Button>
          <Button className={classes.submit}
              onClick={() => {
                  setFieldValue('submitted', 'True');
                  setSubmitted(true);
                  return new Promise(resolve => {
                      window.setTimeout(() => {
                              history.push('/submitted');
                              resolve();
                          },
                          2000);
                  });
              }}
              color="primary" type="submit" disabled={!isValid || submitted} variant="contained">
              {submitted ? <CircularProgress size={24} color="inherit" /> : 'Submit'}          </Button>
        )}
        </Grid>
    </Grid>
  );
}

export default FormButtons;
